export default "__VITE_ASSET__CPe0Visv__"